import LogoHome from './LogoHome';

export default LogoHome;
